module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"target":"Target Achievement Rate","achieved":"Achieved","remaining":"Remaining","unit":"¥"}}')
  delete Component.options._Ctor
}
